import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RawHTML } from '@wordpress/element';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    content
  } = attributes;
  return createElement(RawHTML, null, content);
}
//# sourceMappingURL=save.js.map